import { useRef } from 'react';

import { Input } from 'antd';

import '../style.scss';

interface Props {
    value: number;
    record: any;
    onQuantityChange: (record: any, field: string, value: string) => void;
}

export const CustomNumberInput: React.FC<Props> = ({ value, record, onQuantityChange }) => {
    const ref = useRef(null);

    return (
        <Input
            className="custom-number-input"
            type="number"
            min={1}
            value={value}
            ref={ref}
            onFocus={() => {
                ref.current?.select();
            }}
            onChange={(e) => onQuantityChange(record, record.type, e.target.value)}
        />
    );
};
